import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useState } from 'react';
import { Form, Space } from 'antd';
import { BaseQuestionEdit } from './base-question-edit.component';
import { useForm } from 'antd/lib/form/Form';
import styled from 'styled-components';
import { NumberInput, TextLinkButton, TextOptionInput } from '@lib/common';
import { styleVariables } from '@lib/common';
import { PlusCircleOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var fieldType = {
  id: 'id',
  description: 'description',
  type: 'type',
  correctAnswers: 'correctAnswers',
  answerDescription: 'answerDescription'
};
var CorrectAnswerListField = styled(Form).withConfig({
  displayName: "fill-in-blank-question-editcomponent__CorrectAnswerListField",
  componentId: "sc-zcmz4c-0"
})(["margin-left:8px;"]);
var CorrectAnswerListContainer = styled.div.withConfig({
  displayName: "fill-in-blank-question-editcomponent__CorrectAnswerListContainer",
  componentId: "sc-zcmz4c-1"
})(["display:flex;"]);
var CorrectAnswerItemContainer = styled(Space).withConfig({
  displayName: "fill-in-blank-question-editcomponent__CorrectAnswerItemContainer",
  componentId: "sc-zcmz4c-2"
})(["display:flex;&:nth-child(1){flex:4;margin-right:8px;align-items:center;.ant-space-item{&:nth-child(2){width:100%;}}}&:nth-child(2){flex:1;}"]);
var CorrectAnswerNumber = styled.span.withConfig({
  displayName: "fill-in-blank-question-editcomponent__CorrectAnswerNumber",
  componentId: "sc-zcmz4c-3"
})(["color:", ";min-width:20px;font-size:16px;"], styleVariables.colors.blue4);
var ButtonAddMoreAnswer = styled(TextLinkButton).withConfig({
  displayName: "fill-in-blank-question-editcomponent__ButtonAddMoreAnswer",
  componentId: "sc-zcmz4c-4"
})(["color:", " !important;font-weight:500;font-size:14px;margin-bottom:24px;&:hover,&:focus{color:", ";}"], styleVariables.colors.blue4, styleVariables.colors.blue3);
var AddingIcon = styled(PlusCircleOutlined).withConfig({
  displayName: "fill-in-blank-question-editcomponent__AddingIcon",
  componentId: "sc-zcmz4c-5"
})(["margin-right:10px;"]);
var QuestionContentTitle = styled.div.withConfig({
  displayName: "fill-in-blank-question-editcomponent__QuestionContentTitle",
  componentId: "sc-zcmz4c-6"
})(["font-size:14px;font-weight:600;&:nth-child(1){flex:4;}&:nth-child(2){flex:1;}"]);
var QuestionTitleContainer = styled.div.withConfig({
  displayName: "fill-in-blank-question-editcomponent__QuestionTitleContainer",
  componentId: "sc-zcmz4c-7"
})(["display:flex;justify-content:space-between;"]);
export var FillInBlankQuestionEdit = function FillInBlankQuestionEdit(props) {
  var question = props.question,
      index = props.index,
      onDeleteQuestion = props.onDeleteQuestion,
      onUpdateQuestion = props.onUpdateQuestion,
      onUpdateTypeQuestion = props.onUpdateTypeQuestion,
      onCreateAnswer = props.onCreateAnswer,
      createAnswerStatus = props.createAnswerStatus,
      onResetCreateAnswer = props.onResetCreateAnswer,
      onDeleteAnswer = props.onDeleteAnswer,
      deleteAnswerStatus = props.deleteAnswerStatus,
      onResetDeleteAnswer = props.onResetDeleteAnswer,
      onUpdateAnswer = props.onUpdateAnswer,
      onUpdateCorrectAnswer = props.onUpdateCorrectAnswer,
      updateCorrectAnswerStatus = props.updateCorrectAnswerStatus;

  var initFillInBlankUIProps = _objectSpread(_objectSpread({}, question.toJsonObject()), {}, {
    correctAnswers: question.correctAnswers.map(function (c) {
      var modelUI = {
        id: c.id.toString(),
        score: c.score,
        answerId: c.answerId,
        answerDescription: question.answers.find(function (a) {
          return a.id.toString() === c.answerId;
        }).description,
        index: c.index
      };
      return modelUI;
    })
  });

  var _useState = useState(initFillInBlankUIProps),
      questionFillInBlank = _useState[0],
      setQuestionFillInBlank = _useState[1];

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var getFieldValue = form.getFieldValue,
      setFieldsValue = form.setFieldsValue;
  useEffect(function () {
    if (createAnswerStatus || deleteAnswerStatus || updateCorrectAnswerStatus) {
      var fillInBlankUIPropsUpdate = _objectSpread(_objectSpread({}, question.toJsonObject()), {}, {
        correctAnswers: question.correctAnswers.map(function (c) {
          var modelUI = {
            id: c.id.toString(),
            score: c.score,
            answerId: c.answerId,
            answerDescription: question.answers.find(function (a) {
              return a.id.toString() === c.answerId;
            }).description,
            index: c.index
          };
          return modelUI;
        })
      });

      setFieldsValue(fillInBlankUIPropsUpdate);
      setQuestionFillInBlank(fillInBlankUIPropsUpdate);
      createAnswerStatus && onResetCreateAnswer();
    }
  }, [createAnswerStatus, deleteAnswerStatus, onResetCreateAnswer, onResetDeleteAnswer, question, setFieldsValue, updateCorrectAnswerStatus]);
  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    var _name = _slicedToArray(name, 1),
        field = _name[0];

    var questionId = getFieldValue(fieldType.id);

    if (field === fieldType.type) {
      return onUpdateTypeQuestion(questionId, value);
    } else {
      if (field === fieldType.correctAnswers) {
        var _name2 = _slicedToArray(name, 3),
            _index = _name2[1],
            _field = _name2[2];

        if (_field === fieldType.answerDescription) {
          return onUpdateAnswer(_index, value);
        }

        return onUpdateCorrectAnswer(_index, value, _field);
      }

      return onUpdateQuestion(questionId, field, value);
    }
  }, [getFieldValue, onUpdateAnswer, onUpdateCorrectAnswer, onUpdateQuestion, onUpdateTypeQuestion]);
  useEffect(function () {
    if (question) {
      var fillInBlankUIPropsUpdate = _objectSpread(_objectSpread({}, question.toJsonObject()), {}, {
        correctAnswers: question.correctAnswers.map(function (c) {
          var modelUI = {
            id: c.id.toString(),
            score: c.score,
            answerId: c.answerId,
            answerDescription: question.answers.find(function (a) {
              return a.id.toString() === c.answerId;
            }).description,
            index: c.index
          };
          return modelUI;
        })
      });

      setQuestionFillInBlank(fillInBlankUIPropsUpdate);
    }
  }, [question, createAnswerStatus]);
  return /*#__PURE__*/_jsx(Form, {
    form: form,
    name: "question-essay-form",
    initialValues: questionFillInBlank,
    onFieldsChange: onFieldsChange,
    children: /*#__PURE__*/_jsx(BaseQuestionEdit, {
      index: index,
      onDeleteQuestion: onDeleteQuestion,
      explainDisabled: true,
      type: question.type,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(QuestionTitleContainer, {
          children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
            children: "\u0110\xE1p \xE1n"
          }), /*#__PURE__*/_jsx(QuestionContentTitle, {
            children: "\u0110i\u1EC3m"
          })]
        }), /*#__PURE__*/_jsx(CorrectAnswerListField.List, {
          name: "correctAnswers",
          children: function children(fieldsCorrectAnswer) {
            return fieldsCorrectAnswer.map(function (fieldCorrectAnswer) {
              return /*#__PURE__*/_jsxs(CorrectAnswerListContainer, {
                children: [/*#__PURE__*/_jsxs(CorrectAnswerItemContainer, {
                  children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
                    children: ["(", fieldCorrectAnswer.key + 1, ")"]
                  }), /*#__PURE__*/_jsx(CorrectAnswerListField.Item, {
                    name: [fieldCorrectAnswer.name, 'answerDescription'],
                    children: /*#__PURE__*/_jsx(TextOptionInput, {
                      isHiddenAttachment: true,
                      isHiddenDelete: questionFillInBlank.correctAnswers.length <= 1,
                      onDelete: function onDelete() {
                        onDeleteAnswer(fieldCorrectAnswer.key, 'click');
                      },
                      hasImage: false,
                      onShowingUploadImageModal: function onShowingUploadImageModal() {
                        throw new Error('Function not implemented.');
                      }
                    })
                  })]
                }), /*#__PURE__*/_jsx(CorrectAnswerItemContainer, {
                  children: /*#__PURE__*/_jsx(CorrectAnswerListField.Item, {
                    name: [fieldCorrectAnswer.name, 'score'],
                    children: /*#__PURE__*/_jsx(NumberInput, {
                      max: 10,
                      min: 0,
                      step: "0.25",
                      controls: true,
                      addonAfter: "\u0111i\u1EC3m",
                      stringMode: true
                    })
                  })
                })]
              }, fieldCorrectAnswer.key);
            });
          }
        }), /*#__PURE__*/_jsxs(ButtonAddMoreAnswer, {
          type: "link",
          onClick: onCreateAnswer,
          children: [/*#__PURE__*/_jsx(AddingIcon, {}), "Th\xEAm kho\u1EA3ng tr\u1ED1ng"]
        })]
      })
    })
  });
};